class TableAngle {
  isTilted(angle: number): boolean {
    return angle % 90 !== 0;
  }

  isOnSide(angle: number): boolean {
    return angle === 90 || angle === 270;
  }

  isFlat(angle: number): boolean {
    return angle === 0 || angle === 180;
  }

  swapWidthHeight(angle: number): boolean {
    return angle !== 0 && angle !== 180 && (angle % 90 === 0 || angle % 270 === 0);
  }
  getRealWidthHeight(width: number, height: number, angle: number): { width: number; height: number } {
    return this.swapWidthHeight(angle) ? { width: height, height: width } : { width, height };
  }
}

const instance = new TableAngle();
export default instance as TableAngle;
